import React from "react";
import styled from "styled-components";

import { MidHeaderText, NormalText } from "../common.styles";

const EmptyState = ({ emptyIcon, title, details }) => {
    return (
        <EmptyStateWrapper className="animated kudaFadeInUp">
            <div>{emptyIcon}</div>
            <div>
                <MidHeaderText>{title}</MidHeaderText>
                <NormalText>{details}</NormalText>
            </div>
        </EmptyStateWrapper>
    );
};

const EmptyStateWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
    max-width: 100%;
    padding: 124px 20px 20px;
    gap: 32px;
    margin: 0 auto;
    h3 {
        text-align: center;
    }
    p {
        text-align: center;
        margin-top: 12px;
        color: #979797;
    }
`;

export default EmptyState;
